/*******************************************************************************
* @license (c)Copyright Since 2018, SOFTBANK Corp. All rights reserved.
*
*    機能概要     :  サーバから取ってきた商品データをセットする
*    システム名　 :　iTunesCDD
******************************************************************************/
'use strict';
/* 
 * iTunesの商品データのオブジェクト
 */ 
var iTunesData = {

    product: null,

    setProduct: function (data) {

        var resultData = data;

        $.each(resultData.products, function (index, value) {
            if (value.display_compute == "バリアブル" ) {
                // 固定金額フラグ(カスタム項目)
                value.fixedAmountFlag = false;
            } else {
                // 固定金額フラグ(カスタム項目)
                value.fixedAmountFlag = true;
            }
            // 数値に金額用のカンマを付与する
            value.charge_amount = utility.addComma(value.charge_amount);
        });
        // Variableの最大金あがく最低金額セット
        resultData.variable_max_value = utility.addComma(resultData.variable_max_value);
        resultData.variable_min_value = utility.addComma(resultData.variable_min_value);

        // タイムセールフラグ(カスタム項目)
        resultData.timesaleflag = (resultData.timesale_from_datetime == null) ? false : true;
        // 割引フラグ(カスタム項目)
        resultData.discountFlag = (resultData.fluctuation_rate >= 1) ? false : true;

        this.product = resultData;
    }
}